import { Controller } from "stimulus";
import Cookie from "../../entrypoints/src/lib/cookie";

export default class extends Controller {
  connect() {
    this.element.dataset.state = Cookie.getCookie('menu_pin');

    if (!this.element.dataset.state)
      this.element.dataset.state = 'unpin';

    this.updateCookie();
    this.processPin();

    if (this.element.dataset.state === 'pin')
      this.openMenuSidebar();

    this.element.addEventListener('click', () => this.toggleMenu());
  }

  toggleMenu() {
    this.element.dataset.state = this.element.dataset.state === 'pin' ? 'unpin' : 'pin';
    this.updateCookie();
    this.processPin();
  }

  processPin() {
    let gridBody = document.querySelector('#grid-body'),
      pin = this.element.dataset.state === 'pin';

    this.sidebar.setAttribute('aria-pin', this.element.dataset.state);

    if (!gridBody)
      return;

    gridBody.classList.toggle('md:ml-14', !pin);
    gridBody.classList.toggle('md:ml-[22rem]', pin);
  }

  openMenuSidebar() {
    this.sidebar.setAttribute('aria-menu', 'opened');
  }

  updateCookie() {
    Cookie.setCookie('menu_pin', this.element.dataset.state);
  }

  get sidebar() {
    return document.querySelector('#logo-sidebar');
  }
}